(function () {
  angular.module('MktzapApp.Factories')
    .factory('PermissionControlRoutes', PermissionControlRoutes);

    PermissionControlRoutes.$inject = ['$resource'];

  function PermissionControlRoutes ($resource) {
    return $resource('', {}, {
      getAll: { url: apiUrl + '/permission-control/module/getAll', method: 'GET', params: {}, isArray: false },
      getByProfile: { url: apiUrl + '/permission-control/module/getByProfile', method: 'GET', params: {}, isArray: false },
    });
  }
})();
